import { useEffect, useState } from "react"

export function usePagination<T>(data: T[], pageSize: number) {
  const [currentPage, setCurrentPage] = useState(1)

  // Reset to page 1 when data length changes (e.g. filter applied)
  const dataLength = data.length
  useEffect(() => {
    setCurrentPage(1)
  }, [dataLength])

  const totalPages = Math.max(1, Math.ceil(data.length / pageSize))
  const safePage = Math.min(currentPage, totalPages)
  const startIndex = (safePage - 1) * pageSize
  const endIndex = startIndex + pageSize
  const paginatedData = data.slice(startIndex, endIndex)

  const getPageNumbers = (): (number | string)[] => {
    const pages: (number | string)[] = []
    const maxVisiblePages = 5
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) pages.push(i)
    } else {
      if (safePage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i)
        pages.push("...")
        pages.push(totalPages)
      } else if (safePage >= totalPages - 2) {
        pages.push(1)
        pages.push("...")
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i)
      } else {
        pages.push(1)
        pages.push("...")
        pages.push(safePage - 1)
        pages.push(safePage)
        pages.push(safePage + 1)
        pages.push("...")
        pages.push(totalPages)
      }
    }
    return pages
  }

  return {
    paginatedData,
    currentPage: safePage,
    totalPages,
    startIndex,
    endIndex,
    setPage: setCurrentPage,
    getPageNumbers,
  }
}
